import { render, staticRenderFns } from "./filmbox.vue?vue&type=template&id=220ecdd4&scoped=true"
import script from "./filmbox.vue?vue&type=script&lang=js"
export * from "./filmbox.vue?vue&type=script&lang=js"
import style0 from "./filmbox.vue?vue&type=style&index=0&id=220ecdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ecdd4",
  null
  
)

export default component.exports